module.exports = __webpack_public_path__ + "static/ogImage-e556938f7e696a05f5875c2fbe3b8924.png";